var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_49_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 10,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7078 7.04602H4.5V11.8608H13.7078V7.04602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_49_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.10455 7.04602L4.5 9.13986L9.10483 11.8604L13.7074 9.13986L9.10455 7.04602Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_49_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 6,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10483 1.5H4.5V11.8609H9.10483V1.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_49_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.13988L9.10483 11.8604V1.5L4.5 9.13988Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_49_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 1,
    width: 5,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7093 1.5H9.10449V11.8609H13.7093V1.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_49_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.10474 1.5V11.8609L13.7076 9.13988L9.10474 1.5Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_49_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 10,
    width: 6,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10483 10.0127H4.5V16.5H9.10483V10.0127Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_49_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.0127L9.10483 16.5001V12.7333L4.5 10.0127Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_49_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 5,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7112 10.0127H9.10449V16.5H13.7112V10.0127Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_49_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.10474 12.7333V16.5001L13.7114 10.0127L9.10474 12.7333Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.0a68dca366667e0106f8ede270bb1fff.svg";
export { ForwardRef as ReactComponent };